<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-default" style="margin-bottom: 10px;">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a>
              <i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }" /> Contatos
            </a>
          </div>

          <div class="row" v-if="!collapsed">
            <div class="col-sm-12">
              <br />
              <div class="col-sm-9">
                <div class="form-group">
                  <label for="">Nome:</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      :disabled="fieldsDisabled"
                      v-model="empresaSelecionada.contato.nome"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="empresaSelecionada.contato.nome"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              <div class="col-sm-3">
                <div class="form-group">
                  <label for="">CPF:</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      :disabled="fieldsDisabled"
                      v-model="empresaSelecionada.contato.cpf"
                      @keypress="onlyNumbers"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="empresaSelecionada.contato.cpf"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="!collapsed">
            <div class="col-sm-12">
              <br />
              <div class="col-sm-7">
                <div class="form-group">
                  <label for="">Email:</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      :disabled="fieldsDisabled"
                      v-model="empresaSelecionada.contato.email"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="empresaSelecionada.contato.email"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                    <span class="input-group-btn">
                      <a
                        class="btn btn-default"
                        :href="`mailto:${empresaSelecionada.contato.email}`"
                      >
                        <i class="fa fa-paper-plane" />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="">Telefone: </label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      :disabled="fieldsDisabled"
                      v-model="empresaSelecionada.contato.telefone"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-btn-clipboard
                        :data-clipboard-text="empresaSelecionada.contato.telefone"
                      >
                        <i class="fa fa-clipboard"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="pull-right" style="margin: 10px 10px 5px;">
                <button
                  class="btn edit-badge"
                  style="margin-left: 5px;"
                  @click.prevent="fieldsDisabled = !fieldsDisabled"
                >
                  Editar
                </button>
                <button
                  class="btn btn-primary"
                  @click.prevent="updateContact"
                  :disabled="fieldsDisabled"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputCpf from '../../components/Inputs/InputCpf.vue'
import EmpresaService from '../../services/EmpresaService'

export default {
  name: 'empresa-contatos',
  data() {
    return {
      collapsed: true,
      fieldsDisabled: true
    }
  },

  mounted() {},

  methods: {
    onlyNumbers(event) {
      const permitido = /^[0-9]$/
      if (!permitido.test(event.key)) {
        event.preventDefault()
      }
    },

    async updateContact() {
      try {
        await EmpresaService.updateCompanyContact(this.queryUpdate)
        this.$messages.success().toast('Contato atualizado com sucesso !')
        this.$emit('on-update-contact')
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar o contato.')
        console.error(e)
      } finally {
        this.fieldsDisabled = true
      }
    }
  },

  components: {
    InputCpf
  },

  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    queryUpdate() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        nome: this.empresaSelecionada.contato.nome,
        cpfCnpj: this.empresaSelecionada.contato.cpf,
        email: this.empresaSelecionada.contato.email,
        telefone: this.empresaSelecionada.contato.telefone
      }
    }
  },
  watch: {}
}
</script>

<style lang="css" scoped>
a {
  color: #3c8dbc !important;
}

.edit-badge {
  background-color: #52baf7;
  font-size: 13px;
  color: white;
  padding: 1px 4px;
  border-radius: 5px;
  margin: 5px 5px;
  cursor: pointer;
}
</style>
